/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface LinkedInCheckpointRequest {
  linkedin_account_id: string;
  /**
     * @minLength 0
     * @maxLength 32
     */
  code: string;
}
